import { FlowInformation } from '@js/WTPayload'

export function triggerConversionSuccessEvent(
  conversionValue: number,
  flow_information: FlowInformation
) {
  window._wt({
    category: 'api',
    action: 'success',
    location: 'vendor-wizard-cv-transition',
    flow_information,
    indicates: ['user-input'],
    values: [{ type: 'conversion_value', value: conversionValue.toString() }]
  })
}

export function triggerConversionFailureEvent(
  reason: 'error' | 'no_response',
  flow_information: FlowInformation
) {
  window._wt({
    category: 'api',
    action: 'fail',
    flow_information,
    values: [{ type: 'predicted-prospect-value', value: reason }]
  })
}
